import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { StyledFixturesWrapper } from './styled';

import FixtureSlider from '../../../../components/FixtureSlider';
import { formatMatchDay, localToday, useDisplayTimezone } from '../../../../service/localTime';
import moment from 'moment';

const DAY_FORMAT = 'ddd, DD MMM YYYY';

const CalendarContainer = ({ fixturesData, teamId, isLoading }) => {
  const displayTimezone = useDisplayTimezone();
  const timezone = fixturesData.timezone;
  const createDatesArray = React.useCallback(() => {
    const datesArray = !isEmpty(fixturesData.matches)
      ? [
          ...new Set(
            fixturesData.matches.map((fixture) =>
              formatMatchDay(fixture.match_date, { timezone, format: DAY_FORMAT })
            )
          ),
        ].sort((a, b) => moment(a, DAY_FORMAT) - moment(b, DAY_FORMAT))
      : [];
    const today = moment(localToday(DAY_FORMAT), DAY_FORMAT);
    let indexOfToday = datesArray.findIndex((date) =>
      moment(date, DAY_FORMAT).isSame(today, 'day')
    );
    if (indexOfToday < 0 && datesArray.length) {
      indexOfToday = datesArray.findIndex((date) =>
        moment(date, DAY_FORMAT).isSameOrAfter(today, 'day')
      );
      if (indexOfToday < 0) indexOfToday = datesArray.length - 1;
    }
    return [datesArray, Math.max(0, indexOfToday)];
  }, [fixturesData.matches, timezone, displayTimezone]);
  return (
    <StyledFixturesWrapper>
      <FixtureSlider
        userTeamId={teamId}
        matches={fixturesData.matches}
        timezone={timezone}
        datesData={createDatesArray()}
        isLoading={isLoading}
      />
    </StyledFixturesWrapper>
  );
};

export default React.memo(CalendarContainer);
